















import { Component, Prop, Vue } from 'vue-property-decorator';
import Navbar from './Navbar.vue';

@Component({
    components: {
        Navbar,
    },
})

export default class Header extends Vue {
    // Data
    public subtitle: string = 'Endereza tus dientes sin brackets, sin salir de tu casa y a un costo mucho menor que otros tratamientos de ortodoncia convencional.';
    public cta: string = 'Quiero mi kit';
}
